export const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
export const APP_KEY = process.env.VUE_APP_BOT_APP_KEY || '';

/** ClawAgent 等模式须走 LKE V2（SSE），V1 WebSocket 不支持 */
export function useLkeChatV2 () {
    return typeof window !== 'undefined' && window.$lkeApiVersion === 'v2';
}

/** 是否使用 V1 WebSocket 聊天（非 ClawAgent） */
export function useWebSocketChat () {
    return ACCESS_TYPE === 'ws' && !useLkeChatV2();
}
